import { APP_MODAL_ROUTES, ORDER_INBOUNDS_ROUTES } from '@/navigators/routes';
import {
  AppModalStackParams,
  EditOrderItemNoteParams,
  OrderInboundsStackParams,
} from '@/navigators/types';
import {
  CompositeNavigationProp,
  useNavigation,
} from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';
import { useOrderInboundsStore } from '@/stores/order-inbounds-store';

type Navigation = CompositeNavigationProp<
  StackNavigationProp<
    AppModalStackParams,
    APP_MODAL_ROUTES.EditOrderItemNoteModal
  >,
  StackNavigationProp<
    OrderInboundsStackParams,
    ORDER_INBOUNDS_ROUTES.EditOrderItemNote
  >
>;

export const useNavigateToEditOrderItemNote = () => {
  const navigation = useNavigation<Navigation>();

  return useCallback(
    (params: EditOrderItemNoteParams) => {
      if (useOrderInboundsStore.getState().isInOrderInboundsStack) {
        navigation.navigate(ORDER_INBOUNDS_ROUTES.EditOrderItemNote, params);
      } else {
        navigation.navigate(APP_MODAL_ROUTES.EditOrderItemNoteModal, params);
      }
    },
    [navigation],
  );
};
